<template>
	<div>
		<AppDropdownMenu
			class="app-dropdown-menu"
			left
			bottom
			rounded="lg"
			:width="menuWidth"
			:nudge-bottom="26"
			v-model="showMenu"
			:min-width="menuWidth"
			:max-width="menuWidth"
			:items="filteredMenuOptions"
		>
			<template #activator="{ value }">
				<AnemicButton @click="(e) => e.preventDefault()" class="flex-centerize pa-0" height="25">
					<FeatureVisibilityActivator
						:isOpen="value"
						:isLocked="isLocked"
						:isLoading="isLoading"
						:isVisible="isVisible"
						@click.native="(e) => e.preventDefault()"
					/>
				</AnemicButton>
			</template>
			<template #list-title>
				<Col @click.prevent.stop="" class="menu-header-container">
					<GroupFeatureVisibilityForMembersGroupActivator
						v-bind="menuHeaderItem"
						:key="menuHeaderItem.title"
						v-for="menuHeaderItem in headerItems"
					/>
				</Col>
			</template>
		</AppDropdownMenu>
	</div>
</template>
<script>
const NEW_USERS_EVENT_NAME_SUFFIX = '-for-new-users';
const CURRENT_USERS_EVENT_NAME_SUFFIX = '-for-current-users';

import FeatureVisibilityActivator from '@/components/FeatureVisibility/FeatureVisibilityActivator.vue';
import GroupFeatureVisibilityForNewUsersMenu from '@/components/FeatureVisibility/GroupFeatureVisibilityForNewUsersMenu.vue';
import GroupFeatureVisibilityForMembersGroupActivator from '@/components/FeatureVisibility/GroupFeatureVisibilityForMembersGroupActivator.vue';
export default {
	name: 'GroupFeatureVisibilityDropdown',
	components: {
		FeatureVisibilityActivator,
		GroupFeatureVisibilityForMembersGroupActivator,
	},
	props: {
		isLocked: { type: Boolean },
		isLoading: { type: Boolean },
		isVisible: { type: Boolean },
		allowRemoveAccess: { type: Boolean },
		allowLockVisibility: { type: Boolean },
		showRemoveAccessOnly: { type: Boolean },
	},
	computed: {
		menuOptions() {
			return [
				// {
				// 	prependIconWidth: 20,
				// 	hide: !this.allowLockVisibility,
				// 	prependIcon: 'visibility-visible-locked',
				// 	text: 'Visible - locked for current and new members',
				// 	onClick: this.setVisibleLockedForCurrentAndNewMembers,
				// },
				{ divider: true, hide: !this.allowRemoveAccess || this.showRemoveAccessOnly },
				{
					prependIconWidth: 20,
					text: 'Remove group access',
					onClick: this.removeAccess,
					hide: !this.allowRemoveAccess,
					prependIcon: 'visibility-remove-access',
				},
			];
		},
		filteredMenuOptions() {
			return this.menuOptions.filter((option) => !option.hide);
		},
		headerItems() {
			return this.showRemoveAccessOnly
				? []
				: [
						{
							title: 'Change default for new members',
							menuContent: {
								component: GroupFeatureVisibilityForNewUsersMenu,
								props: {
									isLocked: this.isLocked,
									isVisible: this.isVisible,
									menuItems: this.newUsersMenuItems,
									explanationText: this.newUsersExplanationText,
								},
							},
						},
						{
							title: 'Change visibility for current members',
							menuContent: {
								component: GroupFeatureVisibilityForNewUsersMenu,
								props: {
									menuItems: this.currentUsersMenuItems,
									explanationText: this.currentUsersExplanationText,
								},
							},
						},
				  ];
		},
		newUsersExplanationText() {
			return `You are changing the default for new group members. To change a specific state for a user click next to them`;
		},
		newUsersMenuItems() {
			return [
				{
					prependIconWidth: 20,
					text: `Visible for new members`,
					prependIcon: 'visibility-visible',
					onClick: this.setVisibleForNewUsers,
					isSelected: this.isVisible && !this.isLocked,
				},
				// {
				// 	prependIconWidth: 20,
				// 	text: `Visible - locked for new members`,
				// 	prependIcon: 'visibility-visible-locked',
				// 	onClick: this.setVisibleLockedForNewUsers,
				// 	isSelected: this.isLocked && this.isVisible,
				// },
				{
					prependIconWidth: 20,
					text: `Hidden for new members`,
					prependIcon: 'visibility-hidden',
					onClick: this.setHiddenForNewUsers,
					isSelected: !this.isVisible && !this.isLocked,
				},
			];
		},

		currentUsersExplanationText() {
			return `You are changing the visibility for current group members. To change a specific state for a user click next to them`;
		},
		currentUsersMenuItems() {
			return [
				{
					prependIconWidth: 20,
					prependIcon: 'visibility-visible',
					onClick: this.setVisibleForCurrentUsers,
					text: `Change to visible for all current members`,
				},
				// {
				// 	prependIconWidth: 20,
				// 	prependIcon: 'visibility-visible-locked',
				// 	onClick: this.setVisibleLockedForCurrentUsers,
				// 	text: `Change to visible - locked for all current members`,
				// },
				{
					prependIconWidth: 20,
					prependIcon: 'visibility-hidden',
					onClick: this.setHiddenForCurrentUsers,
					text: `Change to hidden for all current members`,
				},
			];
		},
	},
	methods: {
		notifyParent(eventName, val) {
			this.$emit(eventName, val);
			this.closeMenu();
		},
		setVisibleForNewUsers() {
			this.notifyParent(`set-visible${NEW_USERS_EVENT_NAME_SUFFIX}`);
		},
		setVisibleLockedForNewUsers() {
			this.notifyParent(`set-visible-locked${NEW_USERS_EVENT_NAME_SUFFIX}`);
		},
		setHiddenForNewUsers() {
			this.notifyParent(`set-hidden${NEW_USERS_EVENT_NAME_SUFFIX}`);
		},
		setVisibleForCurrentUsers() {
			this.notifyParent(`set-visible${CURRENT_USERS_EVENT_NAME_SUFFIX}`);
		},
		setVisibleLockedForCurrentUsers() {
			this.notifyParent(`set-visible-locked${CURRENT_USERS_EVENT_NAME_SUFFIX}`);
		},
		setHiddenForCurrentUsers() {
			this.notifyParent(`set-hidden${CURRENT_USERS_EVENT_NAME_SUFFIX}`);
		},
		removeAccess() {
			this.notifyParent('remove-access');
		},
		setVisibleLockedForCurrentAndNewMembers() {
			this.notifyParent('set-visible-locked-for-current-and-new-members');
		},
		open() {
			this.showMenu = true;
		},
		closeMenu() {
			this.showMenu = false;
		},
	},
	data() {
		return {
			menuWidth: 290,
			showMenu: false,
		};
	},
};
</script>
<style lang="scss" scoped></style>
